import cn from 'classnames'
import React from 'react'
import { IContentItemFragment, IContentListItemFragment } from 'src/graphql/generated/hooks'

import { ContentListItem } from './ContentListItem/ContentListItem'

export interface ContentlistProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  items: (IContentItemFragment | IContentListItemFragment | any)[]
  showDocumentType?: boolean
  className?: string
}

export const ContentList: React.FC<ContentlistProps> = ({ items, showDocumentType = false, className = '' }) => {
  return (
    <div className={cn(className, 'bg-white', 'border-y', 'border-zinc-300')}>
      <ul className="divide-y divide-zinc-300">
        {items.map((item, index) => {
          return (
            <li key={index}>
              <ContentListItem item={item} showDocumentType={showDocumentType} />
            </li>
          )
        })}
      </ul>
    </div>
  )
}
